var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorialContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 215,
    viewBox: "0 0 300 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 215,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 21.5,
    width: 182,
    height: 187,
    rx: 3.5,
    fill: "#0071FF",
    fillOpacity: 0.2,
    stroke: "#0071FF",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 20,
    width: 100,
    height: 56,
    rx: 5,
    fill: "#E4E4E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 81,
    width: 100,
    height: 129,
    rx: 5,
    fill: "#E4E4E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    fill: "#F5F5F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F5F5F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 8,
    r: 3,
    fill: "#F5F5F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 3,
    width: 150,
    height: 10,
    rx: 5,
    fill: "#F5F5F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialContent);
export default __webpack_public_path__ + "static/media/tutorialContent.09f98ea98a1be7ee7e4130ed63f6d093.svg";
export { ForwardRef as ReactComponent };